import { CategoryID } from '@sbt-web/network/types';
import classnames from 'classnames';
import React__default from 'react';
import { categoryOrder, categoryLabel, categoryMap } from './config.js';
import CSS from './index.module.scss.js';

const VerticalSelector = function ({ verticalActive, setCategoryInput, verticalClicked, setVerticalClicked, }) {
    const handleVerticalClick = (e) => {
        document
            ?.getElementById(`anchor-${e.target.innerHTML.toLowerCase()}`)
            ?.scrollIntoView();
    };
    // Scroll to the selected category
    React__default.useEffect(() => {
        if (verticalClicked) {
            document?.getElementById(`anchor-${verticalClicked}`)?.scrollIntoView();
        }
    }, [verticalClicked]);
    return (React__default.createElement("div", { className: CSS['col-cat'] },
        React__default.createElement("span", { className: CSS['title-cat'] }, "Categoria"),
        React__default.createElement("div", { className: classnames(CSS['list-group'], CSS['cat-container']), id: "category-nav" }, categoryOrder.map((cat, index) => {
            return (React__default.createElement("button", { key: index, className: classnames(CSS['list-group-item'], CSS[`bg-${verticalActive}`], cat === verticalActive ? CSS['active'] : undefined), onClick: handleVerticalClick }, categoryLabel[cat]));
        })),
        React__default.createElement("button", { id: "desktop-category-reset", className: CSS['all-cat-button'], onClick: () => {
                setCategoryInput({
                    key: CategoryID.Tutte,
                    label: 'Tutte le categorie',
                });
                setVerticalClicked(categoryMap.motori);
            } }, "Cerca in tutte le categorie")));
};

export { VerticalSelector };
//# sourceMappingURL=VerticalSelector.js.map
